const appsetting = {
    apiUrl: 'https://api.dorey-chrs.com', 
    // apiUrl: 'https://localhost:7257',
    token: '6a746132-7823-4842-9d3e-ad90242cb8e6',
    wss:'wss://api.dorey-chrs.com:443',
    // wss:'wss://localhost:7257',
};

export default appsetting;